export const REPORT_ID = "slide-36";
export const SLIDE_NUMBER = 36;
